export default __webpack_public_path__ + "static/media/womens-clothing.3d7dcedf.jpg";